import React from 'react';

function NoMatch() {
    return <h1>404</h1>
}

export default NoMatch;


// WEBPACK FOOTER //
// ./src/scenes/no-match/NoMatch.js